import { render, staticRenderFns } from "./ThePasswordReset.vue?vue&type=template&id=6223213d&scoped=true"
import script from "./ThePasswordReset.vue?vue&type=script&lang=ts"
export * from "./ThePasswordReset.vue?vue&type=script&lang=ts"
import style0 from "./ThePasswordReset.vue?vue&type=style&index=0&id=6223213d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223213d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6223213d')) {
      api.createRecord('6223213d', component.options)
    } else {
      api.reload('6223213d', component.options)
    }
    module.hot.accept("./ThePasswordReset.vue?vue&type=template&id=6223213d&scoped=true", function () {
      api.rerender('6223213d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ThePasswordReset.vue"
export default component.exports